import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Template6 = () => {
    const navigate = useNavigate();

    return (
        <div className="bg-white min-h-screen font-sans">
            <header className="bg-stone-900 text-white p-4 relative z-10">
                <div className="container mx-auto flex justify-between items-center">
                    <button
                        onClick={() => navigate('/TemplateThemes')}
                        className="flex items-center gap-2 px-4 py-2 bg-stone-700 text-white rounded-lg hover:bg-stone-600 transition-colors"
                    >
                        <ArrowLeft size={18} /> Back to Templates
                    </button>
                    <h1 className="text-3xl md:text-4xl font-bold" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Minimalist</h1>
                    <div className="w-24"></div> {/* Placeholder for alignment */}
                </div>
            </header>

            {/* Hero Section - Replicated from DesignerPage6 */}
            <section className="relative bg-stone-900 text-white min-h-[50vh] md:min-h-[60vh] flex items-center justify-center p-6 md:p-12">
                <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{ backgroundImage: "url('https://placehold.co/1920x1080/444444/FFFFFF?text=Hero+Image')" }} />
                <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 lg:gap-16 max-w-5xl mx-auto text-center lg:text-left">
                    <img src="https://placehold.co/200x200/6B7280/FFFFFF?text=Profile" alt="Profile" className="w-40 h-40 md:w-52 md:h-52 object-cover rounded-full border-4 border-white/50 shadow-2xl flex-shrink-0" />
                    <div className="flex flex-col">
                        <h1 className="text-5xl md:text-7xl font-bold" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Minimalist Store</h1>
                        <p className="mt-4 text-lg md:text-xl text-stone-300 max-w-2xl">
                            A curated selection of minimal designs for the modern individual.
                        </p>
                    </div>
                </div>
            </section>

            <main className="max-w-screen-2xl mx-auto p-4 sm:p-6 lg:p-12">
                <div className="lg:grid lg:grid-cols-12 lg:gap-12">

                    {/* Sidebar/Category Filter - Replicated from DesignerPage6 */}
                    <aside className="hidden lg:block lg:col-span-3">
                        <div className="lg:sticky lg:top-24">
                            <h2 className="text-sm font-bold uppercase tracking-widest text-stone-500 mb-6">Categories</h2>
                            <nav className="flex flex-col space-y-2">
                                <a href="#" className="px-4 py-2.5 rounded-md text-left transition-colors duration-200 bg-stone-800 text-white font-semibold">
                                    All Products
                                </a>
                                <a href="#" className="px-4 py-2.5 rounded-md text-left transition-colors duration-200 text-stone-600 hover:bg-stone-200 hover:text-stone-900">
                                    Category 1
                                </a>
                                <a href="#" className="px-4 py-2.5 rounded-md text-left transition-colors duration-200 text-stone-600 hover:bg-stone-200 hover:text-stone-900">
                                    Category 2
                                </a>
                                <a href="#" className="px-4 py-2.5 rounded-md text-left transition-colors duration-200 text-stone-600 hover:bg-stone-200 hover:text-stone-900">
                                    Category 3
                                </a>
                            </nav>
                        </div>
                    </aside>

                    {/* Product Grid - Replicated from DesignerPage6 */}
                    <div className="lg:col-span-9">
                        <div className="lg:hidden mb-6">
                            <select aria-label="Filter by category" className="w-full p-3 bg-white border border-stone-300 rounded-lg shadow-sm focus:ring-2 focus:ring-stone-500 focus:border-stone-500">
                                <option value="">All Products</option>
                                <option value="category-1">Category 1</option>
                                <option value="category-2">Category 2</option>
                                <option value="category-3">Category 3</option>
                            </select>
                        </div>
                        
                        <div className="flex justify-between items-baseline mb-6 border-b border-stone-200 pb-4">
                            <h2 className="text-2xl md:text-3xl font-bold text-stone-900 capitalize" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                                All Products
                            </h2>
                            <span className="text-sm text-stone-500">8 items shown</span>
                        </div>
                        
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
                            {[1, 2, 3, 4, 5, 6, 7, 8].map(id => (
                                <div key={id} className="bg-white p-4 rounded-lg shadow-sm">
                                    <img src={`https://placehold.co/400x500/E0E0E0/333333?text=Product+${id}`} alt={`Product ${id}`} className="w-full h-64 object-cover rounded-md mb-4" />
                                    <h3 className="font-semibold text-gray-800 text-lg">Product Title {id}</h3>
                                    <p className="text-gray-600 mt-1">$XX.XX</p>
                                    <button className="mt-3 w-full px-4 py-2 bg-gray-800 text-white rounded-md hover:bg-gray-700 transition-colors">Add to Cart</button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </main>

            <footer className="bg-stone-800 text-white text-center p-6 mt-8">
                <p>&copy; 2025 Minimalist Store. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default Template6;